<div class="unauth-area not-found" *ngIf="!userService.user">
  <div class="unauth-area__form-wrapper">
    <img alt="logo entity" src="../../assets/images/entity-logo.svg" routerLink="/" class="cursor-pointer"/>
    <h2 style="margin-top: 16px">Pagina non trovata!</h2>
  </div>
</div>
<div class="not-found" *ngIf="userService.user">
  <h2>Pagina non trovata!</h2>
</div>
